import React from 'react';
import {TextField, useTheme} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {BSTheme} from '../../AppTheme';

export interface AuthInputProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  secure: boolean;
  isDisabled?: boolean;
  onBlur?: () => void;
  isError?: boolean;
}

const AuthInput: React.FC<AuthInputProps> = ({
  placeholder,
  value,
  onChange,
  secure,
  isDisabled,
  isError,
  onBlur = () => {},
}) => {
  const theme = useTheme<BSTheme>();
  const border_color = isDisabled
    ? theme.palette.extended.sigInInputBorderColorDisabled
    : isError
    ? theme.palette.extended.errorColor
    : theme.palette.extended.sigInInputBorderColor;

  const useStyles = makeStyles((theme: BSTheme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
      border: 'solid 1px',
      borderColor: border_color,
      borderRadius: '12px',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      width: '360px',
      height: '60px',
      color: theme.palette.common.black,
      fontFamily: 'RobotoFlex',
      fontWeight: 400,
      fontSize: '16px',
      '&.Mui-focused': {
        border: 'solid 1.5px',
        borderColor: border_color,
      },
    },
    input: {
      border: 'none',
      padding: '16px 22px',
      borderRadius: '12px',
      '&:disabled': {
        color: theme.palette.common.black,
        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.5)',
      },
    },
    disabled: {
      color: 'rgba(0, 0, 0, 0.5)',
    },
    underline: {
      '&&&:before': {
        borderBottom: 'none',
      },
      '&&:after': {
        borderBottom: 'none',
      },
    },
  }));
  const classes = useStyles();

  return (
    <TextField
      type={secure ? 'password' : 'email'}
      disabled={isDisabled ?? false}
      placeholder={placeholder}
      InputProps={{classes}}
      variant="standard"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
    />
  );
};

export default AuthInput;
